'use strict';
import { isNumber } from '@aretheyhappy/utils';
const store = new Map();
/**
 * Provides basic key value storage
 */
class KV {
    /**
     * Get object with the specified key
     * @param key
     * @returns
     */
    static get(key) {
        if (!store.has(key))
            return undefined;
        return store.get(key);
    }
    /**
     * Set an object in the store with the set optional experation time
     * @param key
     * @param val
     * @param expires_in
     */
    static set(key, val, expires_in = false) {
        store.set(key, val);
        //  Set expiring key
        if (isNumber(expires_in)) {
            setTimeout(() => {
                store.delete(key);
            }, expires_in);
        }
    }
    /**
     * Check if the store has a key
     * @param key
     * @returns
     */
    static has(key) {
        return store.has(key);
    }
    /**
     * Remove an item from the store
     * @param key
     */
    static clear(key) {
        store.delete(key);
    }
    /**
     * Remove everything from the store
     */
    static clearAll() {
        store.clear();
    }
}
export { KV };
export default KV;
//# sourceMappingURL=KV.js.map